import { promisify } from "./utils/Promisify";

function showFilePickerModalFnDescriptor(modalName: string) {
  return {
    type: "SHOW_FILE_PICKER_MODAL_BY_NAME" as const,
    payload: { modalName },
  };
}

export type TShowFilePickerModalArgs = Parameters<typeof showFilePickerModalFnDescriptor>;
export type TShowFilePickerModalDescription = ReturnType<typeof showFilePickerModalFnDescriptor>;
export type TShowFilePickerModalActionType = TShowFilePickerModalDescription["type"];

async function showFilePickerModal(...args: TShowFilePickerModalArgs) {
  return promisify(showFilePickerModalFnDescriptor)(...args);
}

function closeFilePickerModalFnDescriptor(modalName: string) {
  return {
    type: "CLOSE_FILE_PICKER_MODAL" as const,
    payload: { modalName },
  };
}

export type TCloseFilePickerModalArgs = Parameters<typeof closeFilePickerModalFnDescriptor>;
export type TCloseFilePickerModalDescription = ReturnType<typeof closeFilePickerModalFnDescriptor>;
export type TCloseFilePickerModalActionType = TCloseFilePickerModalDescription["type"];

async function closeFilePickerModal(...args: TCloseFilePickerModalArgs) {
  return promisify(closeFilePickerModalFnDescriptor)(...args);
}

export { showFilePickerModal, closeFilePickerModal };
